import { Navigate, Outlet } from 'react-router';

import { TManagedConfigDto } from '@app-velocity/av-api-v2';

import { useGetConfig } from '../query/useGetConfig';

/**
 * Props for a protected route component.
 */
export type FlagProtectedRouteProps = {
  /**
   * The path to redirect to if the user is not authenticated.
   */
  redirectPath: string;
  flag: keyof TManagedConfigDto;
};

export const FlagProtectedRoute = ({
  redirectPath,
  flag,
}: React.PropsWithChildren<FlagProtectedRouteProps>) => {
  const { data: config } = useGetConfig();

  if (!config) return null;

  const shouldRedirect = !config.config || !config.config[flag];

  if (shouldRedirect) {
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};
